// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { IdentityDelete } from '../../../../types/server/modules/identity/delete';

export type * from '../../../../types/server/modules/identity/delete';

export const createDelete = ( requests: Requests ): IdentityDelete => ({
  passkey_delete: Object.assign(( params,headers ) => {
      return requests.delete( `/auth/passkey/:id`, params, headers );
    }, { operation: 'identity:passkey-delete', route: 'DELETE /auth/passkey/:id', subdomain: 'identity', visibility: 'private' } as const )
});
